import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { searchBackends } from "@shared/agents-metadata/web/web-agent-metadata";

export const WebConnectionForm = ({ form, placeholders }: { form: any; placeholders: Record<string, string> }) => {
    const getInputType = (key: string) => {
        if (key.includes("apiKey") || key.includes("cx")) return "password";
        if (key.includes("maxResults") || key.includes("minContentLength") || key.includes("relevanceThreshold"))
            return "number";
        return "text";
    };

    const selectedBackend = form.watch("config.defaultSearchBackend") || "tavily";

    const relevantKeys = Object.entries(placeholders).filter(([key]) => {
        if (key === "defaultSearchBackend") return true;
        if (key.startsWith("google.") && selectedBackend === "google") return true;
        if (key.startsWith("tavily.") && selectedBackend === "tavily") return true;
        if (key.startsWith("duckduckgo.") && selectedBackend === "duckduckgo") return true;
        if (key.startsWith("bing.") && selectedBackend === "bing") return true;
        return false;
    });

    return relevantKeys.map(([key, placeholder]) => {
        return (
            <FormField
                key={key}
                control={form.control}
                name={`config.${key}`}
                render={({ field }) => (
                    <FormItem>
                        <FormLabel className="capitalize">
                            {key.charAt(0).toUpperCase() +
                                key
                                    .slice(1)
                                    .replace(/([A-Z])/g, " $1")
                                    .replace(/\./g, " ")}
                        </FormLabel>
                        <FormControl>
                            {key === "defaultSearchBackend" ? (
                                <Select value={field.value} onValueChange={field.onChange}>
                                    <SelectTrigger className="w-full">
                                        <SelectValue />
                                    </SelectTrigger>
                                    <SelectContent>
                                        {searchBackends.map((provider) => (
                                            <SelectItem value={provider} key={provider}>
                                                <div className="flex items-center space-x-2">
                                                    <img
                                                        src={`/assets/providers/${provider}.svg`}
                                                        alt={provider.charAt(0).toUpperCase() + provider.slice(1)}
                                                        className="h-4 w-4 flex-shrink-0"
                                                    />
                                                    <span>{provider.charAt(0).toUpperCase() + provider.slice(1)}</span>
                                                </div>
                                            </SelectItem>
                                        ))}
                                    </SelectContent>
                                </Select>
                            ) : key === "tavily.searchDepth" ? (
                                <Select value={field.value} onValueChange={field.onChange}>
                                    <SelectTrigger className="w-full">
                                        <SelectValue placeholder={placeholder} />
                                    </SelectTrigger>
                                    <SelectContent>
                                        <SelectItem value="basic">Basic</SelectItem>
                                        <SelectItem value="advanced">Advanced</SelectItem>
                                    </SelectContent>
                                </Select>
                            ) : (
                                <Input placeholder={placeholder} type={getInputType(key)} {...field} />
                            )}
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                )}
            />
        );
    });
};
